import { Util } from '@antv/g6';
import { DrawOpts } from 'ui/workflows/flowchart/types';
import { Position } from 'ui/workflows/flowchart/constants';
import { shapeNames } from '../../../constants';
import { DrawFooterDetailsOptions } from '../../baseWithFooter/baseWithFooter.types';
import { getDefaultYStart } from '../../baseWithFooter/baseWithFooter.utils';
import { getPositionRelativeToShape, getAllOffsets } from '../../../utils';

export const getWrapperPadding = (options: DrawOpts['options']) =>
  Util.formatPadding(options.padding);

export const getContentPadding = (options: DrawOpts['options']) => {
  return Util.formatPadding(options[shapeNames.footerContentWrapper]?.padding);
};

export const getChildNodeMargins = (options: DrawOpts['options']) =>
  getAllOffsets(options[shapeNames.childNode]);

export const getChildNodesYStart = ({
  options,
  yRelativeTo = shapeNames.divider,
  group,
}: Pick<DrawFooterDetailsOptions, 'group' | 'options' | 'yRelativeTo'>) => {
  const [contentWrapperTop] = getContentPadding(options);
  const defaultY = getDefaultYStart(options);
  const y = yRelativeTo
    ? getPositionRelativeToShape({
        relativeTo: yRelativeTo,
        style: options[shapeNames.footerContentWrapper],
        defaultPosition: defaultY,
        group,
        position: Position.Bottom,
      })
    : defaultY;

  return y + contentWrapperTop;
};

export const getChildNodeDimensions = (opts: DrawFooterDetailsOptions) => {
  const { options, size } = opts;
  const [width] = size;
  const [, wrapperPaddingRight, , wrapperPaddingLeft] = getWrapperPadding(options);
  const contentPadding = getContentPadding(options);
  const childPadding = getChildNodeMargins(options);
  const [, contentWrapperRight, , contentWrapperLeft] = contentPadding;
  const offsetLeft = wrapperPaddingLeft + contentWrapperLeft;
  const offsetRight = wrapperPaddingRight + contentWrapperRight;
  const y = getChildNodesYStart(opts);

  return {
    childPadding,
    contentPadding,
    offsetLeft,
    offsetRight,
    width: width - offsetLeft - offsetRight,
    x: offsetLeft,
    y,
  };
};
